import { Box, Flex, Text, Tooltip } from "@mantine/core";
import { OverflownText } from "../../../../../OverflownText";
import { GeneratedChosenIcon } from "../../../../../../icons/x-symbol-svgrepo-com";
import { stripHtml } from "../../../../../../utils";

const Texts = ({
  title,
  description,
  isGenerated,
}: {
  title: string;
  description: string;
  isGenerated: boolean;
}) => {
  return (
    
    <Flex maw={"calc(100vw - 927px)"} w={700}>
      {isGenerated && (
        <Tooltip
          position="top"
          label={"Automatically generated by Bagel AI"}
          withinPortal
        >
          <Box
            w={22}
            pr={3}
            mr={6}
            m={0}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <GeneratedChosenIcon />
          </Box>
        </Tooltip>
      )}
      { <Tooltip
        maw={500}
        multiline
        label={
          <Box>
            <Text>{title}</Text>
            <Text mt="xs">{stripHtml(description)}</Text>
          </Box>
        }
      >
        <Box>
          <OverflownText 
            maw='28vw'
            lineClamp={1} 
            size="sm" 
            weight={600} 
            color="#212529">
           
            <Text
              sx={{
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              {title}
            </Text>
          </OverflownText>
        </Box>
        
      </Tooltip>}
    </Flex>

  );
};

export default Texts;
